import { Component, type ReactNode } from 'react';

/**
 * Keeps one broken part (a map that failed to load) from blanking the whole app. Shows the
 * fallback, or nothing, in its place.
 */
export class ErrorBoundary extends Component<
  { fallback?: ReactNode; onError?: (error: unknown) => void; children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: unknown) {
    console.error(error);
    this.props.onError?.(error);
  }

  override render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children;
  }
}
